/* eslint-disable @typescript-eslint/no-explicit-any */

import { CONSTANTS } from "@constants/index";
import localSlice from "@slices/local.slice";
import { store } from "@store/index";
import commonUtils from "@utils/common.utils";

function handleResponse(res: any, navigate?: any) {
  if (!res.ok) {
    if (
      res.status === CONSTANTS.HTTP_STATUS.FORBIDDEN ||
      res.status === CONSTANTS.HTTP_STATUS.NOT_FOUND ||
      res.status === CONSTANTS.HTTP_STATUS.INTERNAL_SERVER_ERROR ||
      res.status === CONSTANTS.HTTP_STATUS.INVALID_DATA
    ) {
      commonUtils.toastService(
        res?.data ? commonUtils.flattenObjectToString(res?.data) : "error",
        "error"
      );
    } else if (res.status === CONSTANTS.HTTP_STATUS.UNAUTHORIZED) {
      store.dispatch(localSlice.actions.clearStorage(null));
      localStorage.clear();
      commonUtils.toastService(
        res?.data ? commonUtils.flattenObjectToString(res?.data) : "error",
        "error"
      );
      setTimeout(() => {
        navigate.push("/");
      }, 2000);
    } else if (res.status === CONSTANTS.HTTP_STATUS.BAD_REQUEST) {
      return res;
    } else {
      commonUtils.toastService(
        res?.data ? commonUtils.flattenObjectToString(res?.data) : "error",
        "error"
      );
      return res;
    }
  }

  return res;
}

export default handleResponse;
